import {
  BenchmarkStatsDataType,
  IndustryCategoryComparisonStatsType,
} from "@redotech/redo-model/team-industry-category/industry-comparison-stats";
import * as z from "zod/v4";

const comparisonStatisticValue = z.number().optional();

const comparisonStatistic = z.object({
  title: z.string(),
  merchantValue: comparisonStatisticValue,
  industryValue: comparisonStatisticValue,
  type: z.enum(BenchmarkStatsDataType),
  lowerIsBetter: z.boolean(),
});

export const getIndustryCategoryComparisonStats = {
  name: "getIndustryCategoryComparisonStats" as const,
  input: z.object({
    teamId: z.string(),
    categoryId: z.optional(z.string()),
    dateRange: z.object({ startDate: z.date(), endDate: z.date() }),
  }),
  output: z.object({
    statistics: z.record(
      z.enum(IndustryCategoryComparisonStatsType),
      comparisonStatistic,
    ),
  }),
};
